var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#727831",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.318 8.873c-2.104-.784-5.057-.934-8.786.141a.9.9 0 0 0-.651.865v11.998a.9.9 0 0 0 1.15.865c3.35-.966 5.909-.837 7.658-.185.866.323 1.28.466 1.808.604 3.297.862 5.842.56 7.679-.505.68-.395 1.123-.808 1.356-1.12a.9.9 0 0 0 .178-.538V9c0-.867-1.105-1.233-1.622-.537-.095.127-.359.373-.815.638-1.416.82-3.473 1.065-6.32.32-.45-.117-.827-.247-1.635-.548zm8.592 11.775c-.14.126-.351.285-.637.45-1.416.822-3.473 1.066-6.32.321-.45-.117-.826-.246-1.635-.548-1.883-.702-4.446-.895-7.637-.157V10.568c3.033-.77 5.374-.618 7.008-.009.865.323 1.28.466 1.808.604 3.14.821 5.599.586 7.413-.359v9.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.681 35.513V21.877a.9.9 0 1 0-1.8 0v13.636a.9.9 0 1 0 1.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.407 32.438c-3.154 0-5.83 1.537-5.83 3.731s2.676 3.731 5.83 3.731 5.83-1.537 5.83-3.73c0-2.195-2.676-3.732-5.83-3.732zm0 1.8c2.291 0 4.03.999 4.03 1.931 0 .933-1.739 1.931-4.03 1.931-2.292 0-4.03-.998-4.03-1.93 0-.933 1.738-1.932 4.03-1.932zM33.156 37.748a3.277 3.277 0 0 0 3.267-3.287 3.277 3.277 0 0 0-3.267-3.286 3.277 3.277 0 0 0-3.268 3.286 3.277 3.277 0 0 0 3.268 3.287zm0-1.8a1.477 1.477 0 0 1-1.468-1.487c0-.822.659-1.486 1.468-1.486.809 0 1.467.664 1.467 1.486 0 .823-.658 1.487-1.467 1.487z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.a4467068d0c2693f85947fcd850a26d0.svg";
export { ForwardRef as ReactComponent };